import { render, staticRenderFns } from "./HtmlSitecore.vue?vue&type=template&id=6df3161d"
import script from "./HtmlSitecore.vue?vue&type=script&lang=js"
export * from "./HtmlSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports